// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sc-user-input--button-icon-wrapper[data-v-2256d352]{display:block;background:none;border:none;padding:0;margin:0;outline:none;cursor:pointer}", ""]);
// Exports
module.exports = exports;
